// extracted by mini-css-extract-plugin
module.exports = {"member":"Team_member__345gB","who":"Team_who__NI1Ac","membertext":"Team_membertext__y3A-y","socicons":"Team_socicons__1_1Wb"};